import { Flex } from "@mantine/core";
import { useCallback, useEffect } from "react";

import { useSalesContext } from "../../../sales-context/SalesContext";
import { useProductOfferStore } from "../../../stores";
import { EligibilityStatus, SaleProgress } from "../../../types";
import { IntegratedFlow } from "./IntegratedFlow";
import { useInitDisclosureLanguage } from "./language-selector/useInitDisclosureLanguage";
import { EnrollFailureScreen } from "./StepSpecific/EnrollFailure";
import { SaleView } from "./StepSpecific/SaleView";

export function ProductSaleFlow() {
    const { sessionId, analytics } = useSalesContext();
    const selectedProduct = useProductOfferStore((state) => state.getSelectedProduct(sessionId));

    // Seed the disclosure language from the task locale once per session (expert can override).
    useInitDisclosureLanguage();

    useEffect(() => {
        void analytics.dispatcher.dispatchAction("PageShown", "sale-tool");
    }, [analytics.dispatcher]);

    const { getProductInfo } = useProductOfferStore.getState();

    const handleOnPrimarySaleComplete = useCallback(() => {
        useProductOfferStore.getState().updateSelectedProduct(sessionId, undefined);
    }, [sessionId]);

    return selectedProduct?.saleProgress === SaleProgress.InProgress &&
        selectedProduct.status === EligibilityStatus.Eligible ? (
        <IntegratedFlow product={selectedProduct} />
    ) : (
        <Flex data-testid="product-sale-flow-container" h={"100%"} w={"100%"}>
            {/* Endgame */}
            {selectedProduct?.saleProgress === SaleProgress.Success ||
            selectedProduct?.saleProgress === SaleProgress.Declined ? (
                <SaleView
                    onPrimarySaleComplete={handleOnPrimarySaleComplete}
                    status={selectedProduct.saleProgress}
                    productInfo={getProductInfo(sessionId, selectedProduct.productSku)}
                />
            ) : null}

            {/* Show SaleView when product is not eligible */}
            {selectedProduct &&
            selectedProduct.status !== EligibilityStatus.Eligible &&
            selectedProduct.saleProgress !== SaleProgress.Failure ? (
                <SaleView
                    onPrimarySaleComplete={handleOnPrimarySaleComplete}
                    status={selectedProduct.status}
                    productInfo={getProductInfo(sessionId, selectedProduct.productSku)}
                />
            ) : null}

            {/* Alternate Endgame */}
            {selectedProduct?.saleProgress === SaleProgress.Failure ? (
                <EnrollFailureScreen isProductAsurionBilled={selectedProduct.isProductAsurionBilled} />
            ) : null}
        </Flex>
    );
}
